var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-automator__button l-automator__button fas",on:{"click":_vm.emitClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }